export class LatestImportInStateEvent {}
